import ArrowLeftIcon from '@/assets/app/left_arrow.svg?react';
import ArrowRightIcon from '@/assets/app/right_arrow.svg?react';
import SearchIcon from '@/assets/app/search.svg?react';
import { useEffect, useRef, useState } from 'react';
import Mark from 'mark.js';
import './index.css';
import summaryCommonStore from '@/store/summaryCommon.store';
export interface ISearchBarMobileProps {
  onCancel?: () => void;
  querySelector: string;
}

const SearchBarMobile: React.FC<ISearchBarMobileProps> = (props) => {
  const { querySelector, onCancel } = props;
  const markRef = useRef<Mark | null>(null);
  const [searchValue, setSearchValue] = useState('');
  const resultDom = useRef<NodeListOf<Element> | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalIndex, setTotalIndex] = useState(0);
  const [active, setActive] = useState(false);
  const inpuRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    const dom = document.querySelectorAll(querySelector);
    const markInstance = new Mark(dom);
    markRef.current = markInstance;
  }, [querySelector]);

  useEffect(() => {
    markRef.current?.unmark({
      done: function () {
        resultDom.current = null;
      },
    });
    markRef.current?.mark(searchValue, {
      className: 'text-mx-tertiary font-400',
      done: function (total) {
        if (total === 0) {
          setCurrentIndex(0);
          setTotalIndex(0);
        } else {
          resultDom.current = document.querySelectorAll(
            `${querySelector} mark`
          );
          setTotalIndex(total);
          setCurrentIndex(1);
          jumpTo(1);
        }
      },
    });
    summaryCommonStore.getState().setIsScrolled(true);
  }, [searchValue]);

  const jumpTo = (index: number) => {
    const realIndex = index - 1;
    if (resultDom.current) {
      resultDom.current.forEach((dom) => {
        dom.classList.remove('bg-[rgba(73,129,242,0.5)]');
        dom.classList.add('bg-[rgba(73,129,242,0.2)]');
      });
      resultDom.current[realIndex].classList.add('bg-[rgba(73,129,242,0.5)]');
      resultDom.current[realIndex].classList.remove(
        'bg-[rgba(73,129,242,0.2)]'
      );
      resultDom.current[realIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  const handleInputChange = (val: string) => {
    setSearchValue(val);
  };
  const handlePrev = () => {
    if (resultDom.current) {
      if (currentIndex <= 1) {
        jumpTo(totalIndex);
        setCurrentIndex(totalIndex);
      } else {
        jumpTo(currentIndex - 1);
        setCurrentIndex(currentIndex - 1);
      }
    }
  };

  const handleNext = () => {
    if (resultDom.current) {
      if (currentIndex === totalIndex) {
        jumpTo(1);
        setCurrentIndex(1);
      } else {
        jumpTo(currentIndex + 1);
        setCurrentIndex(currentIndex + 1);
      }
    }
  };

  return (
    <div className="flex items-center w-full">
      <div
        onClick={() => {
          // setActive(true);
          // inpuRef.current?.focus();
        }}
        onBlur={() => {
          setActive(false);
        }}
        className={`
        flex-1 rounded-2.5 
        flex items-center font-400
        b-1 b-solid 
        h-9 bg-white
        ${active ? ' b-mx-primary' : 'b-#ECEEF3'}
      `}
      >
        <SearchIcon className="size-4 ml-4 mr-2" />
        <input
          ref={inpuRef}
          onChange={(e) => {
            handleInputChange(e.target.value);
          }}
          // onFocus={() => {
          //   setActive(true);
          // }}
          value={searchValue}
          autoFocus
          className="my-input b-0 outline-0 text-3 text-mx-secondary flex-1 mr-2"
          placeholder="文件名/关键词/会议概要"
        />
        {/* <CircleCloseIcon
        className="size-4 cursor-pointer mr-1.25"
        onClick={() => {
          markRef.current?.unmark();
          setSearchValue('');
        }}
      />
      <div className="w-0.25 h-4 bg-#CED2D9 mr-2" /> */}
        {searchValue && (
          <>
            <ArrowLeftIcon onClick={handlePrev} className="size-4 mr-2" />
            <div className="text-3.5 text-mx-quaternary">
              <span className="text-mx-secondary">{currentIndex}</span>/
              <span>{totalIndex}</span>
            </div>
            <ArrowRightIcon onClick={handleNext} className="size-4 ml-2 mr-4" />
          </>
        )}
      </div>
      <div
        className="text-mx-secondary text-3.5 ml-6"
        onClick={() => {
          markRef.current?.unmark();
          onCancel?.();
        }}
      >
        取消
      </div>
    </div>
  );
};

export default SearchBarMobile;
